import { useState } from "react";
import { Outlet } from "react-router-dom";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./app-sidebar";
import { AppHeader } from "./app-header";
import { CommandMenu } from "@/components/command-menu/command-menu";
import { useInactivityLock } from "@/hooks/use-inactivity-lock";

export function AppLayout() {
  useInactivityLock();
  const [cmdOpen, setCmdOpen] = useState(false);

  return (
    <SidebarProvider>
      {/* Skip-to-main-content: WCAG 2.2 §2.4.1 — keyboard/screen reader bypass */}
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <AppSidebar />
      <SidebarInset>
        <AppHeader onSearchOpen={() => setCmdOpen(true)} />
        <main id="main-content" className="flex-1 overflow-auto" tabIndex={-1}>
          <div className="mx-auto w-full max-w-screen-2xl px-4 py-6 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </SidebarInset>
      <CommandMenu open={cmdOpen} onOpenChange={setCmdOpen} />
    </SidebarProvider>
  );
}
